export function heroSlider() {
    let slidersContainer = $(".hero-media");

    if (slidersContainer.length) {

        let curSlider = slidersContainer.find(".hero-slider");
        let curSliderNav = slidersContainer.find(".hero-slider-nav");

        if (curSlider.find(".hero-slider-item").length > 1) {

            curSlider.slick({
                dots: false,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                asNavFor: curSliderNav,
                nextArrow: "<button class='next'><svg width='51' height='12' viewBox='0 0 51 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 5C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7V5ZM51 6L41 0.226497V11.7735L51 6ZM1 7H42V5H1V7Z' fill='#ED174F'/></svg></button>",
                prevArrow: "<button class='prev'><svg width='51' height='12' viewBox='0 0 51 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.05176e-05 6L10 11.7735V0.226497L3.05176e-05 6ZM50 7C50.5523 7 51 6.55228 51 6C51 5.44772 50.5523 5 50 5V7ZM9.00003 7H50V5H9.00003V7Z' fill='#ED174F'/></svg></button>",
                responsive:[
                    {
                        breakpoint: 1023,
                        settings: {
                            arrows: false,
                        }
                    },
                ]
            });

            curSliderNav.slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                asNavFor: curSlider,
                focusOnSelect: true,
                // centerMode: true,
                infinite: false,
                arrows: false,
                responsive:[
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                ]
                
            });
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroSlider.js